<script setup>
import { NODE_META } from './utils/nodeFactory';

const emit = defineEmits(['addNode']);

const blocks = [
  { type: 'message', labelKey: 'FLOWS.BUILDER.NODES.MESSAGE' },
  { type: 'whatsapp_list', labelKey: 'FLOWS.BUILDER.NODES.WHATSAPP_LIST' },
  { type: 'buttons', labelKey: 'FLOWS.BUILDER.NODES.BUTTONS' },
  { type: 'media', labelKey: 'FLOWS.BUILDER.NODES.MEDIA' },
  { type: 'handoff', labelKey: 'FLOWS.BUILDER.NODES.HANDOFF' },
  { type: 'fallback', labelKey: 'FLOWS.BUILDER.NODES.FALLBACK' },
  { type: 'end', labelKey: 'FLOWS.BUILDER.NODES.END' },
];

const onDragStart = (event, type) => {
  event.dataTransfer.setData('application/fluxobuilder-node', type);
  event.dataTransfer.effectAllowed = 'move';
};
</script>

<template>
  <aside class="w-48 shrink-0 border-r border-n-weak bg-n-solid-1 p-3 overflow-y-auto">
    <p class="mb-2 text-xs font-semibold uppercase text-n-slate-10">
      {{ $t('FLOWS.BUILDER.SIDEBAR.TITLE') }}
    </p>
    <div class="flex flex-col gap-2">
      <button
        v-for="block in blocks"
        :key="block.type"
        type="button"
        draggable="true"
        class="flex items-center gap-2 px-2 py-2 text-sm rounded-lg border border-n-weak bg-n-solid-2 hover:bg-n-alpha-2 cursor-grab text-n-slate-12"
        @dragstart="onDragStart($event, block.type)"
        @click="emit('addNode', block.type)"
      >
        <span
          class="flex items-center justify-center w-6 h-6 rounded text-white"
          :class="NODE_META[block.type === 'fallback' ? 'message' : block.type]?.color"
        >
          <span :class="NODE_META[block.type === 'fallback' ? 'message' : block.type]?.icon" class="text-sm" />
        </span>
        {{ $t(block.labelKey) }}
      </button>
    </div>
    <p class="mt-3 text-[11px] leading-4 text-n-slate-10">
      {{ $t('FLOWS.BUILDER.SIDEBAR.HINT') }}
    </p>
  </aside>
</template>
